export default __webpack_public_path__ + "static/media/lightblue.ce52ce7e.jpg";